import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const PendingMembershipScreen = loadable(
  () => pMinDelay(import('./PendingMembershipScreen'), 300),
  { fallback: <Loading /> }
);

const AsyncPendingMembershipScreen = props => {
  const pageConfig = {
    headerType: 'simple',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <PendingMembershipScreen { ...props } />
    </ApplicationLayout>
  );
};

AsyncPendingMembershipScreen.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncPendingMembershipScreen;
